module.exports = __webpack_public_path__ + "img/XVG.52f49fba.svg";